import { getCourtPlace, setCourtPlace } from 'helper/LocalStorage';

export const getUrlCourtCode = () => {
    let url = checkUpdatedURL()
    return url 
}
export const getUrlCourtId = () => {
    let id = checkUpdatedURL(true)
    return id
}

function checkUpdatedURL(isId) {
    let local = JSON.parse(localStorage.getItem("court_place"))
    const path = window.location.pathname;
    let checkUrl = path.split('/');
    if ((local && local.length > 1) && checkUrl[1]) {
        let court = local.find(data => data.code === checkUrl[1])
        if (!court) {
            court = local[0]
        }
        setCourtPlace(court)
        return isId ? court.id : court.code
    } else if (getCourtPlace() && getCourtPlace().id) {    
        return !isId ? getCourtPlace().code : getCourtPlace().id
    } else {
        return !isId ? checkUrl[1] ? checkUrl[1] : 'stc' : ''
    }
}